import React from 'react';
import {observer} from 'mobx-react';
import {auth} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const EmployeeDirectoryStatus = observer(({model}) => {
  if (!auth.user.admin) return null;
  const employee = model;

  return (
    <div className='md-and-below-hide'>
      <FormattedMessage id={`employees.directory.employee_status.${employee.commitment}`}/>
    </div>
  );
});

export default EmployeeDirectoryStatus;
